import moment from 'moment';
import { PHARMACY_LOCAL } from '../constants/pharmacy-local.constant';
import { CustomNotification } from '../../../../../v2-components/Notification';
import { Notification } from '../../../../../v2-components/Notification/constant';

export const validateClosingTime = ({ schedule }) => {
	console.log('schedule: ', schedule);
	if (schedule.open === PHARMACY_LOCAL.CLOSED || schedule.close === PHARMACY_LOCAL.CLOSED) {
		return true;
	}
	const openingMoment = moment(schedule.open, 'HH:mm:ss');
	const closingMoment = moment(schedule.close, 'HH:mm:ss');

	const result = closingMoment.isSameOrAfter(openingMoment);

	if (!result) {
		CustomNotification({
			type: Notification.type.error,
			message: Notification.message.error,
			description: `Debe corregir el horario del día ${
				PHARMACY_LOCAL.SCHEDULE_DAYS[schedule.day - 1]
			}, asegurese que el horario de apertura sea menor al de cierre`,
		});
		return false;
	}

	return true;
};
